import { useCallback, useTransition } from 'react';

import { X } from 'lucide-react';

import { Badge } from '@/_components';
import { dateTime } from '@/_shared';

import type { AdvanceFilter } from './types';

import { ActionButton } from '../actions';

export function FilterBadge<T>({
  f,
  handleSubmitAdvFilters,
}: {
  f: AdvanceFilter<T>;
  handleSubmitAdvFilters: (v: AdvanceFilter<T>) => void;
}) {
  const [isPending, startTransition] = useTransition();

  const handleClearFilter = useCallback(
    (f: AdvanceFilter<T>) => () => {
      startTransition(() => {
        handleSubmitAdvFilters({
          ...f,
          applied: false,
        });
      });
    },
    [handleSubmitAdvFilters]
  );

  const { title, selectedType, filterValue } = f;
  const filterValueWithComma = filterValue?.split('|||').join(', ') ?? '';
  let fValue = filterValueWithComma;
  if (f.fieldType === 'date') {
    const values = filterValueWithComma.split(',');
    const convertedValue = values.map((v) => dateTime.format(v, 'MM/DD/YYYY'));
    fValue = convertedValue.join(', ');
  }

  let selectedTypeLabel = selectedType.name ?? '';
  if (selectedTypeLabel.toLocaleLowerCase() === 'match') {
    selectedTypeLabel = 'Matches';
  }

  return (
    <Badge className="relative line-clamp-2 flex w-full min-w-0 items-center justify-start rounded-lg pt-1 pr-7 pb-1.5 text-left normal-case">
      <div className="max-h-13 overflow-y-auto">
        {selectedType?.labelValue ?? (
          <>
            {title} <span className="lowercase">{selectedTypeLabel}</span>
          </>
        )}{' '}
        {!selectedType?.labelValue && <span className="font-semibold">{fValue}</span>}
      </div>
      <span className="absolute right-0 ml-1 cursor-pointer" onClick={handleClearFilter(f)}>
        <ActionButton showLoader={isPending} icon={X} aria-label="Clear filter" title="Clear filter" />
      </span>
    </Badge>
  );
}
